<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <span class="eyebrow">Retail flow</span>
            <h4 class="card-title">Stage distribution</h4>
            <GChart
                :settings="{ packages: ['corechart'] }"
                type="BarChart"
                :data="chartData"
                :options="chartOptions"
                :resizeDebounce="500"
            ></GChart>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummaryStagesCard",
    components: {
        GChart,
    },
    props: {
        counts: {
            type: Object,
            required: true,
        },
    },
    computed: {
        chartData() {
            return [
                ["Stage", "Count", { role: "style" }],
                ["Leads", this.counts.leads, "#7fb3d5"],
                ["Qualification", this.counts.qualification, "#5dade2"],
                ["Appointment", this.counts.appointment, "#48c9b0"],
                ["Estimate", this.counts.estimate, "#f5b041"],
                ["Closing", this.counts.closing, "#eb984e"],
                ["Sold", this.counts.sold, "#52be80"],
                ["Rejected", this.counts.rejected, "#ec7063"],
            ];
        },
        chartOptions() {
            return {
                legend: { position: "none" },
                height: 280,
                backgroundColor: "transparent",
                chartArea: { left: 95, top: 15, width: "75%", height: 220 },
                hAxis: { minValue: 0, textStyle: { color: "#4c5968", fontSize: 14 } },
                vAxis: { textStyle: { color: "#4c5968", fontSize: 16 } },
                tooltip: { textStyle: { color: "#28323c", fontSize: 16 } },
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}

.dashboard-card .card-body {
    background-color: #ffffff;
}
.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 16px;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}
</style>